const CookieConsent: React.FC = (): JSX.Element => {
    return (
        <div className="cookie-consent"> <span>This website uses cookies to ensure our users get the best experience. See our <a href="/privacy.html" className="ml-1">Privacy Policy</a> </span>
            <div className="mt-2 d-flex align-items-center justify-content-center g-2"><button className="cookie-button">OK</button></div>
        </div>
    );
}

export default CookieConsent;